import React, { useId } from "react";
import useModal from "components/modal/useModal";
import ModalCloseButton from "components/modal/components/closeButton";
import Tooltip from "components/tooltips/Tooltips";
import { AppProDownload, AppProPitch, useAppProLabel } from "components/modal/dataModal/data/ModalAppPro/AppProContent";

/** Centred version: the pitch on the left, the QR code and the stores on the right (stacked on a phone). */
const ModalAppPro = () => {
    const { toggle } = useModal();
    const label = useAppProLabel();
    const titleId = useId();

    return (
        <div role="dialog" aria-modal="true" aria-labelledby={titleId} className="relative p-8">
            <div className="absolute right-6 top-6">
                <Tooltip text={label("close", "Fermer")} placement="bottom">
                    <ModalCloseButton onClick={() => toggle()} label={label("close", "Fermer")} />
                </Tooltip>
            </div>
            <div className="flex flex-col gap-8 md:flex-row md:items-center">
                <div className="min-w-0 flex-1 md:pr-2">
                    <AppProPitch titleId={titleId} />
                </div>
                <div className="w-full shrink-0 md:w-[300px]">
                    <AppProDownload />
                </div>
            </div>
        </div>
    );
};

export default ModalAppPro;
